import classNames from 'classnames';
import React from 'react';
import { useTheme } from 'styled-components';
import { getTagColor, statusClasses, StatusBadgeSC } from './status-badge.styled';
import { TTagSize, TTagVariant } from './status-badge.types';

interface StatusBadgeProps
  extends Omit<
    React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>,
    'ref' | 'children'
  > {
  variant?: TTagVariant;
  Icon?: (p: React.SVGProps<SVGSVGElement>) => JSX.Element;
  size?: TTagSize;
  label?: React.ReactNode;
  colorLabel?: boolean;
}

const StatusBadge: React.FunctionComponent<StatusBadgeProps> = ({
  variant = 'default',
  className,
  Icon,
  label,
  size = 'large',
  colorLabel = false,
  ...rest
}) => {
  const theme = useTheme();

  const color = React.useMemo(() => getTagColor(theme, variant), [theme, variant]);

  return (
    <StatusBadgeSC
      className={classNames(
        statusClasses.component,
        className,
        `${statusClasses.component}-${variant}`,
        `${statusClasses.component}-${size}`,
        {
          [`${statusClasses.component}-has-icon`]: !!Icon,
        },
      )}
      color={color}
      {...rest}
    >
      <span className={statusClasses.dot}></span>
      {label ? (
        <span
          className={classNames(statusClasses.label, {
            [`${statusClasses.label}-color`]: colorLabel,
          })}
        >
          {label}
        </span>
      ) : null}
    </StatusBadgeSC>
  );
};

export default StatusBadge;
